import Button from '@mui/material/Button'

export interface iCartItems {
  price_id: string
  quantity: number
  sid: string
  name?: string
  desc?: string
  price?: number
  total?: number
}

//Just stubbing out for now
export default function PaymentCheckoutPlan({items}: {items: any[]}) {
  const numItems = items.reduce((acc, item) => acc + item.quantity, 0)

  const handleCheckout = async () => {
    const line_items: any[] = items.map((item) => {
      return {
        id: item.id,
        product_id: item.product_id,
        extra_seats: item.seat_quantity,
        name: item.name,
      }
    })
    const body = JSON.stringify({items: line_items})
  }

  return (
    <div className='App'>
      <Button
        onClick={handleCheckout}
        variant={'contained'}
        size='small'
        sx={{
          color: 'black',
          textTransform: 'none',
          fontWeight: 400,
          width: '250px',
          background: '#ffd814',
          borderColor: '#fcd200',
          borderRadius: '100px',
          '&:hover': {
            bgcolor: '#ffd814',
            borderColor: '#fcd200',
          },
        }}
      >
        Proceed To Checkout
      </Button>
    </div>
  )
}
